module.exports = __webpack_public_path__ + "assets/download.278bf32c.svg";